import CustomButton from './Button';
import PropTypes from 'prop-types';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BackButton = ({ onClick }) => (
  <CustomButton
    type="button"
    startIcon={<ArrowBackIcon />}
    onClick={onClick}
    sx={{ textAlign: 'left', m: 0, mt: 2 }}>
    Back
  </CustomButton>
);

BackButton.propTypes = {
  onClick: PropTypes.func
};

export default BackButton;
